import { apiClient, APIResponse } from './client';

export interface LicenseObligationRules {
  can: string[];
  cant: string[];
  must: string[];
}

export interface LicenseObligations {
  license: {
    id: number;
    spdxidentifier?: string;
    spdxfullname?: string;
    licensesummary?: string;
  };
  rules: LicenseObligationRules;
}

export class LicenseAPI {
  static async getRules(licenseId: number): Promise<APIResponse<LicenseObligations>> {
    return apiClient.get<LicenseObligations>(`/licenses/${licenseId}/rules`);
  }
}
